import React from 'react'
import { Tooltip as ChakraTooltip } from '@chakra-ui/react'

const Tooltip = ({...rest}) => {
    return(
        <ChakraTooltip bg="gray.500"  placement="left" {...rest} hasArrow arrowSize={6} />
    )
}

export { Tooltip }